<div class="whiteboard-label">
  <div *ngIf="active === true">
    <div
      class="whiteboard-label__handle whiteboard-label__handle--top-left"
      cdkDrag
      (cdkDragMoved)="dragMoved($event, 'corner1')"
      [cdkDragFreeDragPosition]="dragHandles.corner1"
    ></div>
    <div
      class="whiteboard-label__handle whiteboard-label__handle--top-right"
      cdkDrag
      (cdkDragMoved)="dragMoved($event, 'corner2')"
      [cdkDragFreeDragPosition]="dragHandles.corner2"
    ></div>
    <div
      class="whiteboard-label__handle whiteboard-label__handle--bottom-right"
      cdkDrag
      (cdkDragMoved)="dragMoved($event, 'corner3')"
      [cdkDragFreeDragPosition]="dragHandles.corner3"
    ></div>
    <div
      class="whiteboard-label__handle whiteboard-label__handle--bottom-left"
      cdkDrag
      (cdkDragMoved)="dragMoved($event, 'corner4')"
      [cdkDragFreeDragPosition]="dragHandles.corner4"
    ></div>
    <div
      class="whiteboard-label__handle whiteboard-label__handle--move"
      cdkDrag
      (cdkDragMoved)="translateHandleMoved($event)"
      [cdkDragFreeDragPosition]="dragHandles.translate"
    ></div>
  </div>

  <div 
    class="whiteboard-label__label" 
    #textRef
    contenteditable="true"
    [ngClass]="{'whiteboard-label__label--active': active === true}"
    data-placeholder="Type.."
    [attr.data-id]="id"
  >
  </div>
</div>